import { ReactComponent as NZGovt } from 'assets/images/NZGovt-logo-compact.svg';

export const LogoNZGovt = NZGovt;
